import { type RecipeDefinition, type RecipeVariantRecord, defineRecipe } from '@plurall/elo-v3';

export const dashboardLinkRootRecipe: RecipeDefinition<RecipeVariantRecord> = defineRecipe({
  className: 'dashboard-link',
  base: {
    display: 'block',
    textDecoration: 'none',
    color: 'inherit',
    caretColor: 'transparent',
    borderRadius: 'shape.12',
    cursor: 'pointer',

    _focusVisible: {
      outline: '2px solid {colors.action.focus.ring.primary}',
      outlineOffset: '2px',
    },
  },
});

export const dashboardLinkCardRecipe: RecipeDefinition<RecipeVariantRecord> = defineRecipe({
  className: 'dashboard-link__card',
  base: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    gap: 'space.8',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '56px',
  },
});

export const dashboardLinkLabelRecipe: RecipeDefinition<RecipeVariantRecord> = defineRecipe({
  className: 'dashboard-link__label',
  base: {
    whiteSpace: 'nowrap',
    flexGrow: 1,
    fontSize: 'font-size.medium',
  },
});

export const dashboardLinkIconRecipe: RecipeDefinition<RecipeVariantRecord> = defineRecipe({
  className: 'dashboard-link__icon',
  base: {
    flexShrink: 0,
  },
});

export const dashboardLinkArrowRecipe: RecipeDefinition<RecipeVariantRecord> = defineRecipe({
  className: 'dashboard-link__arrow-right',
  base: {
    flexShrink: 0,
  },
});
